import * as yup from 'yup'
import i18next from 'i18next'
import '../i18n/i18n'

export const enquiryReasons = [
  'general',
  'campaignsFundraising',
  'donations',
  'merchandise',
  'partnerships',
  'pledge',
  'pressMedia',
  'privacyPolicy',
  'universityClub',
  'vacanciesVolunteering',
]

export type FormFields = {
  firstName: string
  lastName: string
  emailAddress: string
  phoneNumber: string
  enquiryReason: string
  messageBody: string
  captchaToken: string
}

export enum FieldNames {
  firstName = 'firstName',
  lastName = 'lastName',
  emailAddress = 'emailAddress',
  phoneNumber = 'phoneNumber',
  enquiryReason = 'enquiryReason',
  messageBody = 'messageBody',
  captchaToken = 'captchaToken',
}

export const ContactFormValidationSchema = yup.object().shape({
  firstName: yup.string().required(i18next.t('firstNameRequiredField')),
  lastName: yup.string().required(i18next.t('lastNameRequiredField')),
  emailAddress: yup
    .string()
    .required(i18next.t('emailRequiredField'))
    .email(i18next.t('emailInvalidField')),
  phoneNumber: yup.string(),
  reason: yup.string(),
  messageBody: yup.string().required(i18next.t('messageRequiredField')),
  captchaToken: yup.string().required(i18next.t('captchaRequiredField')),
})
